/**
 * Options for header with tooltip
 */
export interface HeaderWithTooltipOptions {
  tooltipPosition?: 'above' | 'below' | 'left' | 'right';
  tooltipClass?: string;
}

/**
 * Marker interface for header configurations that need dynamic templates
 */
export interface DynamicHeaderConfig {
  _dynamicHeader: 'tooltip';
  labelKey: string;
  tooltipKey: string;
  options?: HeaderWithTooltipOptions;
}

/**
 * Creates a marker object for headerWithTooltip that will be processed
 * by the consuming component
 */
export function createHeaderWithTooltipConfig(
  labelKey: string,
  tooltipKey: string,
  options?: HeaderWithTooltipOptions,
): DynamicHeaderConfig {
  return {
    _dynamicHeader: 'tooltip',
    labelKey,
    tooltipKey,
    options,
  };
}
